import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Progress } from '../../components/ui/progress';
import { Target, Clock } from 'lucide-react';

/**
 * Zeigt Soll-Arbeitszeit (Tag + Woche) mit Fortschrittsbalken "Ist/Soll" an.
 *
 * @param {Object} targetHours      { daily_hours, weekly_hours } aus /api/time-tracking/status
 * @param {number} todayNetMinutes  Netto-Arbeitsminuten heute (aus entry totals + live tick)
 * @param {number} weeklyNetMinutes Netto-Arbeitsminuten der laufenden Woche (weeklyTotals.net)
 */
export const TargetHoursCard = ({ targetHours, todayNetMinutes = 0, weeklyNetMinutes = 0 }) => {
  const daily = Number(targetHours?.daily_hours || 0);
  const weekly = Number(targetHours?.weekly_hours || 0);

  if (!daily && !weekly) return null;

  const todayHours = todayNetMinutes / 60;
  const weeklyHours = weeklyNetMinutes / 60;
  const dailyPct = daily > 0 ? Math.min(100, Math.round((todayHours / daily) * 100)) : 0;
  const weeklyPct = weekly > 0 ? Math.min(100, Math.round((weeklyHours / weekly) * 100)) : 0;

  const fmt = (h) => `${h.toFixed(2).replace('.', ',')} h`;

  return (
    <Card className="border-border/60" data-testid="target-hours-card">
      <CardContent className="pt-4 pb-4 px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div data-testid="target-today">
            <div className="flex items-center justify-between mb-1.5">
              <div className="flex items-center gap-2 text-sm font-medium">
                <Clock className="h-4 w-4 text-primary" />
                <span>Heute</span>
              </div>
              <span className="text-sm text-muted-foreground tabular-nums">
                {fmt(todayHours)} / {fmt(daily)}
              </span>
            </div>
            <Progress value={dailyPct} className="h-2" />
          </div>
          <div data-testid="target-week">
            <div className="flex items-center justify-between mb-1.5">
              <div className="flex items-center gap-2 text-sm font-medium">
                <Target className="h-4 w-4 text-primary" />
                <span>Diese Woche</span>
              </div>
              <span className="text-sm text-muted-foreground tabular-nums">
                {fmt(weeklyHours)} / {fmt(weekly)}
              </span>
            </div>
            <Progress value={weeklyPct} className="h-2" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
